<template>
  <div class="quiz">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="head">
            <div class="result" v-if="countMax < count && isResult">Výsledok testu</div>
            <div class="counter" v-if="countMax >= count">{{count}}/{{countMax}} otázok</div>
            <div class="cancel" v-if="countMax >= count" v-on:click="close"><font-awesome-icon :icon="faTimes"/></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-10 offset-lg-1" v-bind:class="{'answers-center': answersCenter}">
          <transition name="fade" mode="out-in">
            <QuizItem :data="quizItem" v-bind:key="quizItem.Question" v-if="quizItem" v-on:next="changeQuizItem"></QuizItem>
          </transition>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <transition name="fade" mode="out-in">
            <ToothbrushInfo v-bind:key="selectedToothbrush.name" :toothbrush="selectedToothbrush" v-if="selectedToothbrush"></ToothbrushInfo>
          </transition>
        </div>
      </div>
    </div>
    <modal name="close"
           :classes="'close-modal'"
           :adaptive="true"
           :maxHeight="200"
    >
      <div class="title">Určite chceš ukončiť test?</div>
      <div class="dialog-btns">
        <div class="be-you-btn be-you-btn-narrow yes bg--white" v-on:click="closeQuiz">Áno</div>
        <div class="be-you-btn be-you-btn-narrow no bg--pink" v-on:click="closeModal">Nie</div>
      </div>
    </modal>
  </div>
</template>

<script>
import QuizItems from '../quiz'
import QuizItem from './QuizItem.vue'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes'
import InArray from '../helpers/inArray'
import Toothbrushes from '../toothbrushes'
import ToothbrushInfo from '../index/ToothbrushInfo.vue'
import VueScrollTo from 'vue-scrollto'

export default {
  props: [
    'selected',
    'toothbrushColor'
  ],
  data () {
    return {
      quizItem: QuizItems.both[0],
      answers: [],

      count: 1,
      countMax: QuizItems.man.length + 1,

      gender: '',
      color: '',
      environment: '',

      toothbrushes: Toothbrushes,
      toothbrush: false,
      changed: false
    }
  },
  computed: {
    faTimes () {
      return faTimes
    },
    selectedToothbrush () {
      let _selected = {}
      if (this.selected && this.selected.key === this.toothbrushColor && this.toothbrush) {
        _selected = this.selected
        _selected.gender = this.toothbrush.gender
        _selected.environment = this.toothbrush.environment
      } else if (this.selected && this.toothbrush) {
        _selected = this.selected
        _selected.gender = 'both'
      } else if (this.selected) {
        _selected = this.selected
      } else {
        _selected = this.toothbrush
      }

      return _selected !== null && typeof _selected === 'object' ? Object.assign([], _selected) : _selected
    },
    answersCenter () {
      if (this.quizItem.key === 'gender') {
        return true
      }
      return false
    },
    isResult () {
      if (this.selected && this.selected.key === this.toothbrushColor) {
        return true
      }
      return false
    }
  },
  components: {
    FontAwesomeIcon,
    QuizItem,
    ToothbrushInfo
  },
  methods: {
    changeQuizItem: function (e) {
      let _this = this

      // set needed data
      if (InArray(e, ['man', 'woman'])) {
        this.gender = e
      }
      if (this.gender && InArray(e, ['green', 'orange', 'pink-light', 'yellow', 'blue-light', 'pink'])) {
        this.color = e
      }
      if (this.gender && InArray(e, ['environment-1', 'environment-2', 'environment-3', 'environment-4', 'environment-5', 'environment-6'])) {
        this.environment = e
      }

      // if finish
      if (this.count >= this.countMax) {
        let t = this.toothbrushes.find(function (obj) {
          return obj.key === _this.color
        })

        t = Object.assign({}, t)
        t.gender = this.gender
        t.environment = this.environment

        this.toothbrush = t
        this.quizItem = false
        this.$emit('finish', t)
      } else if (this.gender) {
      // next page
        this.quizItem = QuizItems[this.gender][this.count - 1]
      }
      VueScrollTo.scrollTo('.quiz')

      this.count++
    },
    close: function () {
      this.$modal.show('close', {}, {
        height: 'auto'
      })
    },
    closeQuiz: function () {
      this.$router.push({name: 'Index'})
    },
    closeModal: function () {
      this.$modal.hide('close')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/variables.scss";

  .quiz {
    color: $color-blue-text;
    padding-bottom: 80px;
    .head {
      display: flex;
      justify-content: space-between;
      padding: 40px 0 10px 0;
      font-size: 18px;
      .counter, .result {
        font-weight: 300;
      }
      .cancel {
        cursor: pointer;
      }
    }
    .close-modal {
      background-color: $color-yellow;
    }
    .toothbrush-info {
      padding: 50px 0px 0px;
    }
    .answers-center {
      /deep/ .answers {
        text-align: center;
        .radio-component.answer {
          width: auto;
          padding-left: 30px;
          padding-right: 30px;
        }
      }
    }
    @media (max-width: $breakpoint-md) {
      padding-bottom: 45px;
      .head {
        padding: 20px 0 0 0;
      }
      .toothbrush-info {
        padding: 20px 0px 0px 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/quiz/Quiz.vue